/**
 * Created by Administrador on 11/04/2016.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('modelAirCtrl', modelAirCtrl);

    modelAirCtrl.$inject = ['$stateParams','linkService','tabRevenue','modelAircrafts','categories','modelAirService','routesItineraries', 'toastr', '$translate'];

    function modelAirCtrl($stateParams,linkService,tabRevenue,modelAircrafts,categories,modelAirService,routesItineraries, toastr, $translate){
        var vm = this;
        vm.linkService = linkService;
        vm.tabs = tabRevenue;

        vm.itineraryFlights = getItineraryFlightModel(
            vm.linkService, ((routesItineraries.data.name) ? routesItineraries.data.classificationSsrDTOs : []), categories, ((routesItineraries.data.name) ? routesItineraries.data : null)
        );
        vm.modelAircrafts = modelAircrafts.data._embedded.modelAircrafts;
        vm.categories = categories;
        vm.editIndexX = -1;
        vm.auxSegments = [];
        vm.pages = routesItineraries.data.page;
        vm.makerId_modelId = $stateParams.makerId_modelId;

        for(var c=0; c<vm.modelAircrafts.length; c++){
            vm.modelAircrafts[c].makerId_modelId = vm.linkService.getLinkId(vm.modelAircrafts[c]._links.self.href)
        }

        vm.editCapMax = function(indexX){
            if(vm.editIndexX == indexX || vm.editIndexX == -1){
                vm.itineraryFlights[indexX].disabledClass = false;
                vm.itineraryFlights[indexX].showEdit = false;
                vm.editIndexX = indexX;
                vm.auxSegments = angular.copy(vm.itineraryFlights[indexX].ssrAllowedQuantities);
            }
        };

        vm.cancelCapMax = function(indexX){
            vm.itineraryFlights[indexX].disabledClass = true;
            vm.itineraryFlights[indexX].showEdit = true;
            vm.editIndexX = -1;
            vm.itineraryFlights[indexX].ssrAllowedQuantities = angular.copy(vm.auxSegments);
            vm.auxSegments = [];
        };

        vm.saveCapMax = function(valid, indexX) {
            if(valid){
                var max = vm.itineraryFlights[indexX].allowedQuantity;
                var flag = true;
                for (var i = 0; i < vm.itineraryFlights[indexX].ssrAllowedQuantities.length; i++){
                    var ssr_ = vm.itineraryFlights[indexX].ssrAllowedQuantities[i];
                    if(ssr_.allowedQuantity > max) {
                        toastr.error($translate.instant('air.modelAir.maxTotal', {name: ssr_.allowedQuantity, max:max}));
                        flag = false;
                        break;
                    }
                }
                if(flag) {
                    var saveSegment = angular.copy(vm.itineraryFlights[indexX]);
                    modelAirService.updateModelSsr(saveSegment).then(function(res) {
                            if(res != "ok"){
                                vm.itineraryFlights[indexX] = angular.copy(vm.auxSegments);
                            }
                            vm.itineraryFlights[indexX].disabledClass = true;
                            vm.itineraryFlights[indexX].showEdit = true;
                            vm.editIndexX = -1;
                            vm.auxSegments = [];
                     });
                }
            }
        };

        vm.getModelAircraftSsr = function() {
            if(vm.makerId_modelId == null) {
                linkService.reloadRoute(linkService.getCurrentRouteName(), {id: $stateParams.id, page: 0, size: 10, makerId_modelId: ''});
            }else{
                linkService.reloadRoute(linkService.getCurrentRouteName(), {id: $stateParams.id, makerId_modelId: vm.makerId_modelId, page: 0, size: 10});
            }
        }
    }

    function getItineraryFlightModel(linkService,itineraryFlights,categories, data){
        var segmentItineraries = [];
        for(var i=0; i<itineraryFlights.length; i++){
            segmentItineraries.push(
                {
                    "name": itineraryFlights[i].name,
                    "allowedQuantity": itineraryFlights[i].allowedQuantity,
                    "classificationSsrId": itineraryFlights[i].classificationSsrId,
                    "makerId": data.makerId,
                    "modelAircraftId": data.modelAircraftId,
                    "ssrAllowedQuantities": itineraryFlights[i].ssrDTOs,
                    "disabledClass": true,
                    "disabledEdit": false,
                    "showEdit": true,
                    "showSave": false
                }
            );
            var bandDay = "";
        }
        return segmentItineraries;
    }

    function getItineraryFlights2(linkService,itineraryFlights,categories){
        var segmentItineraries = [];
        for(var i=0; i<itineraryFlights.length; i++){
            segmentItineraries.push(
                {
                    "flightNumber": itineraryFlights[i].flightNumber+'_77',
                    "structure": itineraryFlights[i]._embedded.structure,
                    "disabledClass": true,
                    "disabledEdit": false,
                    "showEdit": true,
                    "showSave": false,
                    "segmentDays":[]
                }
            )
            var bandDay = "";
            for(var j=0; j<itineraryFlights[i]._embedded.departuresItinerary.length; j++){
                var dI = itineraryFlights[i]._embedded.departuresItinerary[j];

                if(bandDay == dI.dayOfWeekId){
                    for(var k=0; k<dI._embedded.segmentItineraries.length; k++){
                        var sI = dI._embedded.segmentItineraries[k];
                        segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments.push(
                            {
                                "name": sI._embedded.segment.name,
                                "initials": sI._embedded.segment.initials,
                                "id": linkService.getLinkId(sI._links.self.href),
                                "departureTime": (dI.departureTime).substr(0,5),
                                "takeoffCapacity":sI.takeOffCapacity,
                                "capacities": []
                            }
                        );
                        //classes
                        for(var c=0; c<categories.length; c++){
                            for(var cl=0; cl<categories[c]._embedded.fareClasses.length; cl++){
                                var classId = linkService.getLinkId(categories[c]._embedded.fareClasses[cl]._links.self.href)
                                segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments[segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments.length-1].capacities.push(
                                    {
                                        "iataCode": categories[c]._embedded.fareClasses[cl].iataCode,
                                        "classId": classId,
                                        "value": getValueClass(classId,sI._embedded.segmentClassItis)
                                    }
                                );
                            }
                        }
                    }
                }else{
                    segmentItineraries[i].segmentDays.push(
                        {
                            "segments": []
                        }
                    );
                    for(var k=0; k<dI._embedded.segmentItineraries.length; k++){
                        var sI = dI._embedded.segmentItineraries[k];
                        segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments.push(
                            {
                                "name": sI._embedded.segment.name,
                                "initials": sI._embedded.segment.initials,
                                "id": linkService.getLinkId(sI._links.self.href),
                                "departureTime": (dI.departureTime).substr(0,5),
                                "takeoffCapacity":sI.takeOffCapacity,
                                "capacities": []
                            }
                        );
                        //classes
                        for(var c=0; c<categories.length; c++){
                            for(var cl=0; cl<categories[c]._embedded.fareClasses.length; cl++){
                                var classId = linkService.getLinkId(categories[c]._embedded.fareClasses[cl]._links.self.href)
                                segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments[segmentItineraries[i].segmentDays[segmentItineraries[i].segmentDays.length-1].segments.length-1].capacities.push(
                                    {
                                        "iataCode": categories[c]._embedded.fareClasses[cl].iataCode,
                                        "classId": classId,
                                        "value": getValueClass(classId,sI._embedded.segmentClassItis)
                                    }
                                );
                            }
                        }
                    }
                    bandDay = dI.dayOfWeekId;
                }
            }
        }
        return segmentItineraries;
    }

    function getValueClass(classId,segmentClassItis){
        var res = 0;
        if(segmentClassItis != undefined) {
            for (var i = 0; i < segmentClassItis.length; i++) {
                if (segmentClassItis[i].classId == classId) {
                    res = parseInt(segmentClassItis[i].value);
                    break;
                }
            }
        }
        return res;
    }
})();
